import React, { useEffect, useState } from 'react';
import ConsultBanner from '../../components/ConsultBaneer';
import ConsultCard from '../../components/ConsultCard';
import { getSeoByUrl } from '../../api/api';
import { Helmet } from "react-helmet-async";

const Consult = () => {
const [seoData, setSeoData] = useState({});


  useEffect(() => {
    const fetchSeoData = async () => {
      try {
        const response = await getSeoByUrl("consult"); 
        
         if (response.success && response.data) {
          setSeoData(response.data);
        }
      } catch (error) {
        console.error("Error fetching SEO data:", error);
      }
    };

    fetchSeoData();
  }, []);



  return (
    <div>
       <Helmet>
              <title>
                {seoData.metaTitle || "Consult | Nutrillion"}
              </title>
      
              <meta
                name="description"
                 content={seoData.metaDescription || "DNA based nutrition consultation at Nutrillion"}
              />
      
              <meta
                name="robots"
                content={seoData.robotsTxt || "index, follow"}
              />
      
              <link
                rel="canonical"
                href={
                  seoData.canonicalUrl ||
                  "https://nutrillion.one/consult"
                }
              />
            </Helmet>
      <ConsultBanner />
      <ConsultCard />
    </div>
  );
};

export default Consult;